import script from "./carolAnnouncementModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./carolAnnouncementModal.vue?vue&type=script&setup=true&lang=ts"

import "./carolAnnouncementModal.vue?vue&type=style&index=0&id=e4f5e52a&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4f5e52a"]])

export default __exports__